import { Environment } from "./environment.model";

export const environment: Environment = {
    production: false,
    resourceProviderURI: "https://cms-epa-provider.smilecdr.com/provider-a-fhir",
    crdFhirServer: "https://cms-epa-provider.smilecdr.com/provider-a-fhir",
    payerFhirEndpoint: "https://cms-epa-dtr.smilecdr.com/epa-proxy-fhir",
    issuerURI: "https://cms-epa-provider.smilecdr.com/smartauth-ehr",
    token_endpoint: "/smartauth-ehr/oauth/token",
    clientId: "dtr-facade",
    scopeUrl: "openid patient/*.read patient/*.write profile launch/practitioner",
    dtrAppUrl: "https://cms-epa-dtr.smilecdr.com/dtr-app",
    cdsResourceProviderURI: "https://cms-epa-dtr.smilecdr.com/camel/cds-services",
    cdsAppUrl: "https://cms-epa-dtr.smilecdr.com/dtr-app",
    payerGroupNpiSystem: "http://hl7.org/fhir/sid/us-npi",
    payerGroupNpiValue: "1356441356",
    payerOrgIdentifierSystem: "http://smiledigitalhealth.com/pa-org-identifier",
    coverageUrl: "Coverage?patient={{patientId}}&status=active"
}